import { Icon } from "@mui/material";
import PageLayout from "pages/layout/page-layout";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import brand from "assets/images/logos/mini-logo-transparent-green.png";
import config from "config/config";

const UnderMaintenance = ({ contactEmail = config.contact.infoEmail, homeHref = "/" }) => {
  return (
    <PageLayout>
      <SoftBox
        sx={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: { xs: "1.5rem", md: "3rem" },
          py: { xs: "3rem", md: "5rem" },
          textAlign: "center",
        }}
      >
        <SoftBox sx={{ maxWidth: 720, width: "100%" }}>
          <SoftBox
            component="img"
            src={brand}
            alt="Mama za pet"
            sx={{ height: "4rem", mb: "1.5rem", mx: "auto", display: "block" }}
          />

          <SoftBox
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
              mb: "0.75rem",
            }}
          >
            <Icon
              sx={{
                fontSize: "2rem !important",
              }}
            >
              build
            </Icon>
            <SoftTypography variant="h3" color="dark">
              Stranica je privremeno nedostupna
            </SoftTypography>
          </SoftBox>

          <SoftTypography variant="body2" color="text" sx={{ mb: "1.5rem" }}>
            Radimo kratko održavanje i poboljšanja kako bismo obezbijedili još bolje iskustvo. Hvala
            na strpljenju.
          </SoftTypography>

          <SoftBox
            sx={{
              display: "flex",
              gap: "1rem",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <SoftButton
              variant="outlined"
              color="success"
              component="a"
              href={`mailto:${contactEmail}`}
              sx={{ minWidth: 180 }}
            >
              <Icon sx={{ mr: "0.5rem" }}>mail</Icon>
              Kontaktiraj nas
            </SoftButton>
          </SoftBox>

          <SoftTypography variant="caption" color="text" sx={{ display: "block", mt: "1.5rem" }}>
            Ako si stigla/la ovdje greškom, pokušaj ponovo kasnije ili nam se javi na{" "}
            <a href={`mailto:${contactEmail}`} style={{ textDecoration: "underline" }}>
              {contactEmail}
            </a>
            .
          </SoftTypography>
        </SoftBox>
      </SoftBox>
    </PageLayout>
  );
};

export default UnderMaintenance;
